export class BaseRestService {
    constructor(window) {
        this.window = window;
    }
    async _get(baseUrl, path) {
        const url = `${baseUrl}${path !== null && path !== void 0 ? path : ''}`;
        const response = await this.window.fetch(url, {
            method: "GET",
            headers: {
                accept: "application/json",
            },
            cache: 'no-cache',
            mode: 'cors',
            credentials: 'include',
            referrerPolicy: "no-referrer"
        });
        if (response.status !== 200) {
            throw new Error(`Fetch failed with ${response.status} status code. Details: ${response.statusText}`);
        }
        return await response.json();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS1yZXN0LnNlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc2hhcmVkL3NlcnZpY2VzL3Jlc3QvYmFzZS1yZXN0LnNlcnZpY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFnQixlQUFlO0lBR2pDLFlBQXNCLE1BQWM7UUFDaEMsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7SUFDekIsQ0FBQztJQUVTLEtBQUssQ0FBQyxJQUFJLENBQUksT0FBZSxFQUFFLElBQWE7UUFDbEQsTUFBTSxHQUFHLEdBQUcsR0FBRyxPQUFPLEdBQUcsSUFBSSxhQUFKLElBQUksY0FBSixJQUFJLEdBQUksRUFBRSxFQUFFLENBQUM7UUFDdEMsTUFBTSxRQUFRLEdBQUcsTUFBTSxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUU7WUFDMUMsTUFBTSxFQUFFLEtBQUs7WUFDYixPQUFPLEVBQUU7Z0JBQ0wsTUFBTSxFQUFFLGtCQUFrQjthQUM3QjtZQUNELEtBQUssRUFBRSxVQUFVO1lBQ2pCLElBQUksRUFBRSxNQUFNO1lBQ1osV0FBVyxFQUFFLFNBQVM7WUFDdEIsY0FBYyxFQUFFLGFBQWE7U0FDaEMsQ0FBQyxDQUFDO1FBQ0gsSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtZQUN6QixNQUFNLElBQUksS0FBSyxDQUFDLHFCQUFxQixRQUFRLENBQUMsTUFBTSwwQkFBMEIsUUFBUSxDQUFDLFVBQVUsRUFBRSxDQUFDLENBQUM7U0FDeEc7UUFDRCxPQUFPLE1BQU0sUUFBUSxDQUFDLElBQUksRUFBTyxDQUFDO0lBQ3RDLENBQUM7Q0FDSiJ9